import dayjs from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import RoutesApp from '../../routes';

//Servicios
import { DeclaracionesService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import DJTVSearch from './DJTVSearch';

//Estilos
import right_arrow from '../../assets/imgs/next.png';
import pencil from '../../assets/imgs/edit.png';
import { useTableContext } from '../../contexts/TableContext';

function DJTVSearchContainer() {
    const { masters, SearchParameters } = useGlobalContext();
    const { state } = useTableContext();
    const tablePage = useMemo(() => state.DJTVPage, [state.DJTVPage]);

    const [loader, setLoader] = useState(false);
    const [tableData, setTableData] = useState(buildTableData());
    let apiTablePages;

    useEffect(() => {
        const getDJTVSearchCuantity = async () => {
            try {
                setLoader(true);

                const DJTVSearchCuantity =
                    await DeclaracionesService.totalRecords({
                        ...SearchParameters.declaraciones,
                        tipo: 6,
                    });

                if (DJTVSearchCuantity) {
                    apiTablePages = DeclaracionesService.data;

                    getDJTVSearch();
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getDJTVSearchCuantity();
    }, [tablePage, SearchParameters.declaraciones]);

    async function getDJTVSearch() {
        try {
            setLoader(true);

            const DJTVSearch = await DeclaracionesService.search({
                ...SearchParameters.declaraciones,
                tipo: 6,
                pagina: tablePage,
            });

            if (DJTVSearch) {
                setTableData(buildTableData(DJTVSearch.data, apiTablePages));
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    }

    /**Funcion que crea el objeto para crear la tabla resultado del buscador de DJTVs */
    function buildTableData(data = [], tablePages) {
        return {
            title: 'Declaraciones de DJTV',
            headers: [
                'ID',
                'Viñedo',
                'Titulares',
                'Fecha',
                'Departamento',
                'Seccional',
                ' ',
            ],
            tablePages,
            pagination: 10,
            pageType: 'DJTVPage',
            data:
                data.length > 0
                    ? data.map((dj) => {
                          return {
                              id: `${dj.serie}-T-${dj.numero}`,
                              viniedo: dj.viniedo,
                              titulares: dj.titulares,
                              fecha: dayjs(dj.fecha).format('DD-MM-YYYY'),
                              departamento: masters.Departments?.find(
                                  (ht) => ht.id === dj.departamento
                              )?.nombre.replaceAll('_', ' '),
                              kilosTotales: dj.seccional,
                              icons: (
                                  <div>
                                      <Link
                                          to={
                                              RoutesApp.Declaraciones
                                                  .cosechaProbable + dj.id
                                          }
                                          className="table-icon_container"
                                      >
                                          <img
                                              className="table-icon"
                                              src={right_arrow}
                                              title="Visualizar"
                                              alt="Visualizar"
                                          />
                                      </Link>
                                  </div>
                              ),
                          };
                      })
                    : [],
        };
    }

    return loader ? <Spinner /> : <DJTVSearch tableData={tableData} />;
}

export default DJTVSearchContainer;
